import React from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { primaryColor } from "./colors";
import { primaryGradient } from "./GradientBox";
import {
  FacebookIcon,
  NavigationPath,
  stripSlash,
} from "./navigation/NavigationCommon";
import analytics from "./services/analytics";
import { translation } from "./translations";

export const MenuItem: React.FC<{
  navigationPath?: NavigationPath;
  width?: number;
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}> = (props) => {
  const { pathname } = useLocation();

  const isActive = stripSlash(pathname) === props.navigationPath;
  const width = props.width ?? 120;

  return (
    <Wrapper width={width} onClick={props.onClick}>
      <Background isActive={isActive} />
      <Content isActive={isActive}>{props.children}</Content>
    </Wrapper>
  );
};

export const FacebookMenuItem: React.FC = () => (
  <MenuItem
    width={160}
    onClick={() => {
      analytics.logOpenFacebook();
    }}
  >
    <React.Fragment>
      {translation.navFacebook}
      <FacebookIcon />
    </React.Fragment>
  </MenuItem>
);

const Wrapper = styled.div<{ width: number }>`
  width: ${(props) => props.width}px;
  height: 60px;
  position: relative;
  margin-right: -2px;
`;

const Background = styled.div<{ isActive: boolean }>`
  transform: skew(30deg);
  background: ${(props) => (props.isActive ? primaryGradient : "white")};
  width: 100%;
  height: 100%;
`;

const Content = styled.div<{ isActive: boolean }>`
  position: absolute;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  color: ${(props) => (props.isActive ? "white" : primaryColor)};
  text-transform: uppercase;
  font-weight: bold;
  font-size: 16px;
  text-decoration: none;
  :hover {
    text-decoration: underline;
  }
`;
